export const karaokeRevealOptions = {
  duration: 0.8,
  ease: 'none',
  direction: 'right',
  rightAlpha: 0.5,
  leftAlpha: 1,
};
